import api from "@/lib/api";

/**
 * Thin wrapper around all /api/jobs, /api/career, /api/applications, /api/messages
 * endpoints so pages don't have to hard-code URLs.
 */
export const jobsApi = {
  list: (params) => api.get("/jobs", { params }).then((r) => r.data),
  detail: (id) => api.get(`/jobs/${id}`).then((r) => r.data),
  create: (body) => api.post("/jobs", body).then((r) => r.data),
  update: (id, body) => api.patch(`/jobs/${id}`, body).then((r) => r.data),
  setStatus: (id, status) => api.post(`/jobs/${id}/status`, { status }).then((r) => r.data),
  remove: (id) => api.delete(`/jobs/${id}`).then((r) => r.data),
  mine: () => api.get("/jobs/mine").then((r) => r.data),
  applicants: (id, status) =>
    api.get(`/jobs/${id}/applicants`, { params: status ? { status } : {} }).then((r) => r.data),
  save: (id) => api.post(`/jobs/${id}/save`).then((r) => r.data),
  unsave: (id) => api.delete(`/jobs/${id}/save`).then((r) => r.data),
  saved: () => api.get("/jobs/saved").then((r) => r.data),
  apply: (id, body) => api.post(`/jobs/${id}/apply`, body).then((r) => r.data),
};

export const careerApi = {
  me: () => api.get("/career/me").then((r) => r.data),
  update: (body) => api.put("/career/me", body).then((r) => r.data),
  publicProfile: (userId) => api.get(`/career/${userId}`).then((r) => r.data),
  search: (params) => api.get("/career/search", { params }).then((r) => r.data),
  upload: (file, kind) => {
    const fd = new FormData();
    fd.append("kind", kind);
    fd.append("file", file);
    return api.post("/career/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
};

export const applicationsApi = {
  mine: () => api.get("/applications/mine").then((r) => r.data),
  detail: (id) => api.get(`/applications/${id}`).then((r) => r.data),
  setStatus: (id, body) => api.post(`/applications/${id}/status`, body).then((r) => r.data),
  withdraw: (id) => api.post(`/applications/${id}/withdraw`).then((r) => r.data),
};

export const messagesApi = {
  threads: () => api.get("/messages/threads/mine").then((r) => r.data),
  list: (appId) => api.get(`/messages/${appId}`).then((r) => r.data),
  send: (appId, body) => api.post(`/messages/${appId}`, body).then((r) => r.data),
};

export const employerApi = {
  requestVerification: () => api.post("/employer/verify").then((r) => r.data),
};

// ---- Constants for pickers ----
export const EMPLOYMENT_TYPES = [
  { value: "full-time", label: "Full-time" },
  { value: "part-time", label: "Part-time" },
  { value: "contract", label: "Contract" },
  { value: "internship", label: "Internship" },
  { value: "temporary", label: "Temporary" },
];
export const WORK_MODES = [
  { value: "onsite", label: "On-site" },
  { value: "remote", label: "Remote" },
  { value: "hybrid", label: "Hybrid" },
];
export const EXPERIENCE_LEVELS = [
  { value: "entry", label: "Entry" },
  { value: "mid", label: "Mid" },
  { value: "senior", label: "Senior" },
  { value: "executive", label: "Executive" },
];
export const AVAILABILITY_STATES = [
  { value: "actively_looking", label: "Actively looking" },
  { value: "open", label: "Open to offers" },
  { value: "not_looking", label: "Not looking" },
];
export const INDUSTRY_OPTIONS = [
  "Technology", "Finance", "Healthcare", "Education", "Retail", "Manufacturing",
  "Construction", "Media", "Marketing", "Legal", "Government", "Hospitality",
  "Transport", "Agriculture", "Energy", "Real Estate", "Non-profit", "Other",
];
export const APPLICATION_STATUS_LABELS = {
  submitted: "Submitted",
  under_review: "Under review",
  shortlisted: "Shortlisted",
  interview: "Interview scheduled",
  accepted: "Accepted",
  rejected: "Rejected",
  withdrawn: "Withdrawn",
};

export function formatSalary(salary) {
  if (!salary) return "Negotiable";
  const { min, max, currency = "USD", negotiable } = salary;
  if (!min && !max) return negotiable ? "Negotiable" : "Salary not disclosed";
  const fmt = (n) => `${currency} ${Number(n).toLocaleString()}`;
  if (min && max) return `${fmt(min)} – ${fmt(max)}`;
  return fmt(min || max);
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
}
